import api from "./api";
import { Nullable, ResponseInterface } from "../interfaces";
import { GeneralAppDataDto } from "../interfaces/Dtos";
import { ApplicationVersionDTO } from "../interfaces/Dtos/ApplicationVersionDTO";
import { GeneralParameterDTO } from "../interfaces/Dtos/GeneralParameterDTO";

const baseURL = process.env.REACT_APP_API_HOST;

export const getBaseAppData = async (
  countryID: Nullable<number>
): Promise<Promise<ResponseInterface<GeneralAppDataDto>>> => {
  let uri = `${baseURL}/Application/Facturador`;
  if (!!countryID) {
    uri += `?countryID=${countryID}`;
  }
  try {
    const response = await api.get(uri);

    if (response.status === 200) {
      return response.data;
    }
    return {
      model: null,
      didError: true,
      message: `Server status: ${response.status}`,
      errorMessage: "Server error",
    };
  } catch (error) {
    return {
      model: null,
      didError: true,
      message: `Error: ${error}`,
      errorMessage: "Application error 4",
    };
  }
};

export const getAppVersion = async (): Promise<
  ResponseInterface<ApplicationVersionDTO>
> => {
  const uri = `${baseURL}/Application/GetVersionApplication?ApplicationID=10`;

  try {
    const response = await api.get(uri);

    if (response.status === 200) {
      return response.data;
    }
    return {
      model: null,
      didError: true,
      message: `Server status: ${response.status}`,
      errorMessage: "Server error",
    };
  } catch (error) {
    return {
      model: null,
      didError: true,
      message: `Error: ${error}`,
      errorMessage: "Application error 4",
    };
  }
};

export const getParameter = async (
  parameterName: string
): Promise<ResponseInterface<GeneralParameterDTO>> => {
  const uri = `${baseURL}/GeneralParams/GetParameter`;
  try {
    const response = await api.post(uri, { parameterName });

    if (response.status === 200) {
      return response.data;
    }
    return {
      model: null,
      didError: true,
      message: "Server error",
      errorMessage: `Server status: ${response.status}`,
    };
  } catch (error) {
    return {
      model: null,
      didError: true,
      message: "Error al obtener el parámetro",
      errorMessage: `Error: ${error}`,
    };
  }
};
